module.exports = __webpack_public_path__ + "static/media/foto_vehiculo_frente@2x.35bfb0c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/foto_vehiculo_frente@2x.jpg
// module id = 353
// module chunks = 0